import HelpContainer from './containers/HelpContainer'

export default (store) => ({
  path : 'help',
  component: HelpContainer,
})



// WEBPACK FOOTER //
// ./src/routes/Help/index.js